import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase_config';
import { DEVICE_SUBCOLLECTION, USER_COLLECTION, User } from '../../type';

class UserService {
  async getAll(): Promise<User[]> {
    const q = query(collection(db, USER_COLLECTION), orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    return snap.docs.map(doc => ({ 
      ...doc.data(),
      uid: doc.id 
    } as User));
  }

  async getTokensForUsers(userIds: string[]): Promise<string[]> {
    const allTokens: string[] = [];
    
    for (const userId of userIds) {
      const devicesRef = collection(db, USER_COLLECTION, userId, DEVICE_SUBCOLLECTION);
      const devicesSnapshot = await getDocs(devicesRef);
      
      const tokens = devicesSnapshot.docs
        .map(doc => doc.data().fcmToken)
        .filter(token => token);
      
      allTokens.push(...tokens);
    }
    
    return allTokens;
  };
}

export const userService = new UserService(); 